@let form = detailFormService.form;

<form [formGroup]="form">
  <hlm-tabs [tab]="activeTab()" (tabActivated)="tabActivated($event)">
    <hlm-paginated-tabs-list>
      <button hlmTabsTrigger="general">
        Général
        @if (!etape()?.estDupliquee!) {
          @if (detailFormService.codeEtape.hasError('pattern')) {
            <div
              class="text-feedback-negative-main bg-feedback-negative-lightest p-xxs flex rounded-full"
              hlmTooltipTrigger="Le code étape n'est pas au bon format"
            >
              <ng-icon name="lucideCircleAlert" hlm size="sm" />
            </div>
          } @else if (detailFormService.nom.hasError('required')) {
            <div
              class="text-feedback-negative-main bg-feedback-negative-lightest p-xxs flex rounded-full"
              hlmTooltipTrigger="Le nom de l'étape est obligatoire"
            >
              <ng-icon name="lucideCircleAlert" hlm size="sm" />
            </div>
          }
        }
      </button>
      <button hlmTabsTrigger="contrat">
        Contrat
        @if (!etape()?.estDupliquee! && showErrors()) {
          @if (isRepartitionAnneesCorrect()) {
            <div
              class="text-feedback-negative-main bg-feedback-negative-lightest p-xxs flex rounded-full"
              hlmTooltipTrigger="La répartition par année est incomplète"
            >
              <ng-icon name="lucideCircleAlert" hlm size="sm" />
            </div>
          } @else if (!detailFormService.type.value && !detailFormService.estCertifiante.value) {
            <div
              class="text-feedback-negative-main bg-feedback-negative-lightest p-xxs flex rounded-full"
              hlmTooltipTrigger="Le type est obligatoire si l'étape n'est pas certifiante"
            >
              <ng-icon name="lucideCircleAlert" hlm size="sm" />
            </div>
          } @else if (
            detailFormService.typesContrat.value.includes('apprentissage') && !detailFormService.certification.value
          ) {
            <div
              class="text-feedback-negative-main bg-feedback-negative-lightest p-xxs flex rounded-full"
              hlmTooltipTrigger="Avec un contrat d'apprentissage, une certification est obligatoire"
            >
              <ng-icon name="lucideCircleAlert" hlm size="sm" />
            </div>
          }
        }
      </button>
      <!-- <button hlmTabsTrigger="formations">Formations réglementaires</button> -->
      <button hlmTabsTrigger="objectifs">Objectifs</button>
      <button hlmTabsTrigger="livrables">{{ traductions().livrable | titlecase }}s</button>
    </hlm-paginated-tabs-list>
    <div hlmTabsSeparator></div>
    <div class="mt-lg overflow-y-auto">
      <div hlmTabsContent="general">
        <app-detail-general [form]="detailFormService.general" />
      </div>
      <div hlmTabsContent="contrat">
        <app-detail-contrat
          [form]="detailFormService.contrat"
          [referentiel]="referentiel()"
          [peutModifier]="peutModifierContrat()"
          [showErrors]="showErrors()"
        />
      </div>
      <div hlmTabsContent="formations">
        <app-detail-formations-reglementaires [form]="detailFormService.formationsReglementaires" />
      </div>
      <div hlmTabsContent="objectifs">
        <app-detail-objectifs
          [form]="detailFormService.objectifs"
          [formCertifications]="detailFormService.certifications"
          [cartographie]="cartographie()"
          [referentiel]="referentiel()"
        />
      </div>
      <div hlmTabsContent="livrables">
        <app-detail-livrables [form]="detailFormService.livrables" [referentiel]="referentiel()" />
      </div>
    </div>
  </hlm-tabs>
</form>
